/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MatchingCriteria } from './MatchingCriteria';
import {
    MatchingCriteriaFromJSON,
    MatchingCriteriaFromJSONTyped,
    MatchingCriteriaToJSON,
    MatchingCriteriaToJSONTyped,
} from './MatchingCriteria';

/**
 * 
 * @export
 * @interface ExcludeControls
 */
export interface ExcludeControls {
    /**
     * 
     * @type {string}
     * @memberof ExcludeControls
     */
    tenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof ExcludeControls
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ExcludeControls
     */
    uuid?: string;
    /**
     * 
     * @type {string}
     * @memberof ExcludeControls
     */
    description?: string;
    /**
     * 
     * @type {any}
     * @memberof ExcludeControls
     */
    profile?: any | null;
    /**
     * 
     * @type {string}
     * @memberof ExcludeControls
     */
    controlIds?: string;
    /**
     * 
     * @type {Array<MatchingCriteria>}
     * @memberof ExcludeControls
     */
    matchingCriteria?: Array<MatchingCriteria>;
}

/**
 * Check if a given object implements the ExcludeControls interface.
 */
export function instanceOfExcludeControls(value: object): value is ExcludeControls {
    return true;
}

export function ExcludeControlsFromJSON(json: any): ExcludeControls {
    return ExcludeControlsFromJSONTyped(json, false);
}

export function ExcludeControlsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExcludeControls {
    if (json == null) {
        return json;
    }
    return {
        
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'id': json['id'] == null ? undefined : json['id'],
        'uuid': json['uuid'] == null ? undefined : json['uuid'],
        'description': json['description'] == null ? undefined : json['description'],
        'profile': json['profile'] == null ? undefined : json['profile'],
        'controlIds': json['controlIds'] == null ? undefined : json['controlIds'],
        'matchingCriteria': json['matchingCriteria'] == null ? undefined : ((json['matchingCriteria'] as Array<any>).map(MatchingCriteriaFromJSON)),
    };
}

export function ExcludeControlsToJSON(json: any): ExcludeControls {
    return ExcludeControlsToJSONTyped(json, false);
}

export function ExcludeControlsToJSONTyped(value?: ExcludeControls | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tenantId': value['tenantId'],
        'id': value['id'],
        'uuid': value['uuid'],
        'description': value['description'],
        'profile': value['profile'],
        'controlIds': value['controlIds'],
        'matchingCriteria': value['matchingCriteria'] == null ? undefined : ((value['matchingCriteria'] as Array<any>).map(MatchingCriteriaToJSON)),
    };
}

